import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams, createSearchParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { SearchBar } from "../../../components";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { SendIcon } from "../../../components/icons";
import { useReports } from "../hooks";
import { CustomerSelectSearch } from "../../customers/components";
import { cleanObject } from "../../../helpers/clean-object";
import { formatDisplayDate } from "../../../helpers/date";

interface ISearchForm {
  customerId?: string;
}

export const Reports: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const form = useForm<ISearchForm>({
    mode: "all",
    defaultValues: {
      customerId: searchParams.get("customerId") ?? "",
    },
  });

  const onSubmit = () => {
    const values = form.getValues();
    navigate({
      pathname: "/reports",
      search: `?${createSearchParams(cleanObject(values))}`,
    });
  };

  const customerId = searchParams.get("customerId");
  const where: any = {};
  if (customerId) where.customerId = +customerId;

  const { data, loading } = useReports({ where });

  return (
    <>
      <Header
        title="Rapports SEO"
        subtitle="Rapports hebdomadaires de suivi SEO par client"
        buttons={[
          {
            actionText: "Nouveau rapport",
            bgColor: "indigo",
            textColor: "white",
            link: `/report/create`,
            icon: <SendIcon />,
          },
        ]}
      />

      <div className="main-container">
        <SearchBar
          form={form}
          onSubmit={onSubmit}
          placeholder=""
          advancedFilters={<CustomerSelectSearch form={form} name="customerId" />}
        />

        <div className="p-4 mb-6 bg-white shadow rounded overflow-x-auto">
          {loading ? (
            <Loading />
          ) : !data?.reports?.results?.length ? (
            <EmptyList text="Aucun rapport" />
          ) : (
            <Table>
              <TableHeader>
                <TableRow hover={false}>
                  <TableCell header>Semaine du</TableCell>
                  <TableCell header>Client</TableCell>
                  <TableCell header>Contenu</TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data?.reports?.results?.map((report) => (
                  <TableRow
                    key={`report-${report.id}`}
                    onClick={() => navigate(`/report/${report.id}/update`)}
                  >
                    <TableCell>{formatDisplayDate(report.weekStartDate)}</TableCell>
                    <TableCell>{report.customer?.name}</TableCell>
                    <TableCell className="max-w-xs truncate">{report.content}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </div>
      </div>
    </>
  );
};
